var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['app-loader', ("app-loader--" + _vm.size)]},[_c('app-icon',{staticClass:"app-loader__icon",attrs:{"name":"spinner"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }